module.exports = __webpack_public_path__ + "img/162.d57baa24.jpg";